module.exports = __webpack_public_path__ + "img/制御工学5_7_4.c764792c.png";